import { Component, Input, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/services/config.service';

@Component({
  selector: 'calsoft-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {

  @Input() height: string;
  @Input() background: string;
  @Input() reverse: boolean;
  @Input() reverseDirection: string[];

  reverseDir: boolean[] = [ ];

  get margin() {
    return '-' + this.height;
  }

  constructor(  private configService: ConfigService,) { }
  data: Object;
  breadcrumbtype: any ;
  ngOnInit() {
  
 let breadcrumbtype=   localStorage.getItem('adminBreadcrumbType'); 

 if(breadcrumbtype!=undefined){

  this.breadcrumbtype=breadcrumbtype;

 }else{
  this.breadcrumbtype=3;
 }

    this.reverseDir.push(...[false, false, false, false]);

    if (this.reverseDirection) {
      this.reverseDirection.forEach((dir) => {
        switch (dir) {
          case 'top': {
            this.reverseDir[0] = true;
            break
          }
          case 'right': {
            this.reverseDir[1] = true;
            break
          }
          case 'bottom': {
            this.reverseDir[2] = true;
            break
          }
          case 'left': {
            this.reverseDir[3] = true;
            break
          }
        }
      })
    }
  }

}
